import { render, staticRenderFns } from "./HeaderV1.vue?vue&type=template&id=33f869ca&"
import script from "./HeaderV1.vue?vue&type=script&lang=js&"
export * from "./HeaderV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports